import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

const startRows: RouteRecordRaw = {
    path: '/start',
    component: () => import('../views/Global/StartView.vue'),
    children: [
        {
            path: '',
            name: 'start',
            component: () => import('@/features/products-and-services').then((m) => m.ProductsAndServices),
        },
        {
            path: 'product',
            children: [
                {
                    path: 'airbill',
                    component: () => import('@/features/products-and-services').then((m) => m.AirBill),
                },
                {
                    path: 'banking',
                    name: 'start-banking',
                    component: () => import('@/features/products-and-services').then((m) => m.Banking),
                },
                {
                    path: 'godutch',
                    component: () => import('@/features/products-and-services').then((m) => m.GoDutch),
                },
                {
                    path: 'vivid',
                    component: () => import('@/features/products-and-services').then((m) => m.Vivid),
                },
                {
                    path: 'mollie',
                    component: () => import('@/features/products-and-services').then((m) => m.Mollie),
                },
                {
                    path: 'revolut',
                    component: () => import('@/features/products-and-services').then((m) => m.Revolut),
                },
                {
                    path: 'reconi',
                    component: () => import('@/features/products-and-services').then((m) => m.Reconi),
                },
            ],
        },
        {
            path: 'incorporation',
            name: 'start-incorporation',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartIncorporation.vue'),
            children: [
                {
                    path: 'convert',
                    name: 'start-incorporation-conversion',
                    component: () => import('@/components/Start/components/StartIncorporation.vue'),
                },
            ],
        },
        {
            path: 'share-transfer',
            name: 'share-transfer',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/features/funnels/share-transfer/ShareTransferEntry.vue'),
        },
        {
            path: 'liquidation',
            name: 'start-liquidation',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartAccount.vue'),
        },
        {
            path: 'ubo',
            name: 'start-ubo-registration',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartAccount.vue'),
        },
        {
            path: 'general-flow',
            name: 'start-general-flow',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartAccount.vue'),
        },
        {
            path: 'modification',
            name: 'start-modification',
            component: () => import('@/components/Start/components/StartBvModification.vue'),
        },
        {
            path: 'accounting',
            name: 'start-accounting',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartAccounting.vue'),
        },
        {
            path: 'finances',
            name: 'start-finances',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartFinances.vue'),
        },
        {
            path: 'compliance',
            name: 'start-compliance',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartCompliance.vue'),
        },
        {
            path: 'specialist',
            name: 'start-specialist',
            meta: { layout: Layout.HeaderOnly },
            component: () => import('@/components/Start/components/StartSpecialist.vue'),
        },
        {
            path: ':type(.*)',
            redirect: { name: 'start' },
        },
    ],
};

export default startRows;
